import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { appendToUrlPath } from '../../../../utils';
import InfoToolTip from '../../../@shared/infoToolTip';
import Picture from '../../../@shared/picture';
import { TProductCard } from '../../types/modelsListing.types';
import SummarySpecs from './summarySpecs';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import { appendRootToRichTextInternalLinks } from '../../../../utils/appendRootToRichTextInternalLinks.utils';

const ProductCard: FC<WithTranslation & TProductCard> = (props) => {
  const { title, msrp, description, summarySpecs, assets, msrpDescription, msrpTitle, baseUrl, titleUrl, showModelUrl, onClick, t, bodyTextVisibility, bodySpecVisibility } = props;
  const asset = assets && assets[0];
  const onClickRedirectionDisabled = !titleUrl || showModelUrl === false;

  return (
    <article className="product-card__wrapper">
      <RoutableNotEditableLink
        className={`product-card contenthub-model-listing ${onClickRedirectionDisabled ? 'contenthub-model-listing-none' : ''}`}
        href={appendToUrlPath(baseUrl || '', titleUrl || '')}
        onClick={(e): void => {
          onClickRedirectionDisabled && e.preventDefault();
          onClick();
        }}
      >
        {asset && (
          <div className="contenthub-model-listing__product-card__image-wrapper">
            <Picture
              productImageProps={{
                desktopRendition: asset?.rendition_desktop_size500,
                mobileRendition: asset?.rendition_mobile_size500,
                alt: asset?.alt,
                pictureClassName: 'contenthub-model-listing__product-card__picture--fixed-aspect-ratio',
              }}
            />
          </div>
        )}
        <div className="product-card__content">
          {title ? <h3 className="product-card__title">{title}</h3> : null}
          {msrp ? (
            <>
              <div className="product-card__content-eyebrow contenthub-model-listing__product-card__eyebrow">
                <span className="product-card__msrp">{t('cnhi-startingFrom')}</span>
                <b>{` ${msrp}`}</b>
                {(msrpTitle || msrpDescription) && (
                  <InfoToolTip
                    className="contenthub-model-listing__product-card__info-icon"
                    showIcon={true}
                    clickPreventDefault={true}
                    width={300}
                  >
                    <div className="contenthub-model-listing__product-card__tooltip-wrapper">
                      <Text
                        field={{ value: msrpTitle }}
                        tag="h2"
                        className="contenthub-model-listing__product-card__tooltip-title"
                        editable={false}
                      />
                      <Text
                        field={{ value: msrpDescription }}
                        tag="div"
                        className="contenthub-model-listing__product-card__tooltip-body"
                        editable={false}
                      />
                    </div>
                  </InfoToolTip>
                )}
              </div>
            </>
          ) : null}
          {bodyTextVisibility !== 'hide' && description ? (
            <div className="product-card__description">
              <RichText
                field={{ value: appendRootToRichTextInternalLinks(description) }}
                className={'rich-text'}
                tag="div"
                editable={false}
              />
            </div>
          ) : null}
          {bodySpecVisibility !== 'hide' && summarySpecs?.length ? <SummarySpecs summarySpecs={summarySpecs} /> : null}
        </div>
      </RoutableNotEditableLink>
    </article>
  );
};

export default withTranslation()(ProductCard);
